module.exports = __webpack_public_path__ + "img/logo.f513e093.png";